<template>
    <form class="form-agent-multi-account" @submit.prevent="onSubmit()">
      <fieldset>
          <legend>{{ $t('AGENT_MGMT.FORM.INFO_USER.LABEL') }}</legend>
          <div class="medium-12 columns">
            <label :class="{ error: $v.agentName.$error }">
              {{ $t('AGENT_MGMT.FORM.NAME.LABEL') }}
              <input
                v-model.trim="agentName"
                type="text"
                :placeholder="$t('AGENT_MGMT.FORM.NAME.PLACEHOLDER')"
                @input="$v.agentName.$touch"
              />
            </label>
          </div>        
          <div class="medium-12 columns" v-if="!isEdit">
            <label :class="{ error: $v.agentEmail.$error }">
              {{ $t('AGENT_MGMT.FORM.EMAIL.LABEL') }}
              <input
                v-model.trim="agentEmail"
                type="text"
                :placeholder="$t('AGENT_MGMT.FORM.EMAIL.PLACEHOLDER')"
                @input="$v.agentEmail.$touch"
              />
            </label>
          </div>
      </fieldset>
      <fieldset>
          <legend>{{ $t('AGENT_MGMT.FORM.PARENT_ACCOUNT.LABEL') }}</legend>
          <div class="medium-12 columns" :class="{ error: $v.accessParent.$error }">
            <multiselect
              v-model="accessParent"
              :options="accessParentOptions"
              :searchable="false" 
              :placeholder="$t('AGENT_MGMT.FORM.PARENT_ACCOUNT.PLACEHOLDER')"             
              track-by="id"
              label="name"
              class="no-margin multiselect-wrap--small"              
            >              
            </multiselect>              
          </div>
      </fieldset>
      <fieldset>
          <legend>{{ $t('AGENT_MGMT.FORM.SUBACCOUNT.LABEL') }}</legend>
          <div class="medium-12 columns">
            <div v-for="(item, index) in accounts" :key="`account-${index}`" class="item-account">
              <div  class="row">
                <div class="columns">
                  <multiselect
                    v-model="item.account"
                    :options="getSubaccountOptionsByIndex(index)"
                    :placeholder="$t('AGENT_MGMT.FORM.SUBACCOUNT.PLACEHOLDER')"
                    track-by="id"
                    label="name"
                    class="no-margin multiselect-wrap--small"
                  >
                    <template #noResult>
                      <span>{{ $t('AGENT_MGMT.FORM.SUBACCOUNT.NO_RESULTS') }}</span>
                    </template>
                  </multiselect>
                </div>
                <div class="columns">
                  <multiselect
                    v-model="item.role"
                    :options="roles"
                    :placeholder="$t('AGENT_MGMT.FORM.AGENT_TYPE.PLACEHOLDER')"
                    track-by="name"
                    label="label"
                    class="no-margin multiselect-wrap--small"              
                  >              
                  </multiselect>
                </div>
                <div class="columns column-actions">
                    <woot-button                    
                      v-tooltip.top="`Remover`"
                      icon="dismiss"
                      variant="clear"
                      color-scheme="secondary"
                      type="button"
                      @click="removeRowAccount(index)"
                    />
                </div>
              </div>
              <div v-if="$v.accounts.$each[index].account.$error || $v.accounts.$each[index].role.$error" class="error mt-2">
                <span v-if="$v.accounts.$each[index].account.$error" class="message">{{ $t('AGENT_MGMT.FORM.SUBACCOUNT.ERROR') }}</span>
                <span v-else-if="$v.accounts.$each[index].role.$error" class="message">{{ $t('AGENT_MGMT.FORM.AGENT_TYPE.ERROR') }}</span>
              </div>
            </div>
            <div v-if="$v.accounts.$error && !$v.accounts.minLength" class="row error">
              <span class="message">{{ $t('AGENT_MGMT.FORM.ERROR_MESSAGE_NOT_SELECTED_PARENT_OR_SUBACCOUNT') }}</span>
            </div>
            <woot-button
              v-if="accounts.length < subaccountsSorted.length"
              icon="add"
              color-scheme="success"
              variant="smooth"
              size="small"
              type="button"
              @click="addRowAccount"
            >
              {{ $t('AGENT_MGMT.FORM.ADD_SUBACCOUNT_BUTTON_TEXT') }}
            </woot-button>
          </div>
      </fieldset>        
      <div class="modal-footer">
        <div class="medium-12 columns">
          <woot-submit-button
            type="submit"
            :disabled="
              $v.agentEmail.$invalid ||
              $v.agentName.$invalid ||
              isSubmitting
            "
            :button-text="(!isEdit ? $t('AGENT_MGMT.ADD.FORM.SUBMIT'): $t('AGENT_MGMT.EDIT.FORM.SUBMIT'))"
            :loading="isSubmitting"
          />
          <button class="button clear" @click.prevent="$emit('cancel')">
            {{ $t('AGENT_MGMT.FORM.CANCEL_BUTTON_TEXT') }}
          </button>
        </div>
      </div>
    </form>  
</template>

<script>
import { required, minLength, email, requiredIf } from 'vuelidate/lib/validators';
import { mapGetters } from 'vuex';

export default {
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    isSubmitting: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      agentName: this.value.name || '',
      agentEmail: this.value.email || '',      
      roles: [
        {
          name: 'administrator',
          label: this.$t('AGENT_MGMT.AGENT_TYPES.ADMINISTRATOR'),
        },
        {
          name: 'team_supervisor',
          label: this.$t('AGENT_MGMT.AGENT_TYPES.TEAM_SUPERVISOR'),
        },
        {
          name: 'supervisor',
          label: this.$t('AGENT_MGMT.AGENT_TYPES.SUPERVISOR'),
        },
        {
          name: 'agent',
          label: this.$t('AGENT_MGMT.AGENT_TYPES.AGENT'),
        },
        {
          name: 'seller',
          label: this.$t('AGENT_MGMT.AGENT_TYPES.SELLER'),
        },
        {
          name: 'analyzer',
          label: this.$t('AGENT_MGMT.AGENT_TYPES.ANALYZER'),
        },
        {
          name: 'assistant',
          label: this.$t('AGENT_MGMT.AGENT_TYPES.ASSISTANT'),
        },
        {
          name: 'embed',
          label: this.$t('AGENT_MGMT.AGENT_TYPES.EMBED'),
        },
      ],      
      accessParent: null,
      accessParentOptions: [
        {id: 0, name: 'Não'},
        {id: 1, name: 'Sim'},
      ],
      accounts: [], 
    };
  },
  computed: {
    ...mapGetters({     
      subaccounts: 'subaccounts/getSubaccounts',
      currentAccountId: 'getCurrentAccountId',
    }),
    subaccountsSorted(){
      return [...this.subaccounts].sort((a, b) =>
        a.name.localeCompare(b.name, 'pt-BR', { sensitivity: 'base' })
      );
    },
    isEdit() {
      return Object.keys(this.value).length > 0;
    },
  },
  watch: {
    value: {
      // A função handler será executada logo na criação do componente
      handler(value) {
        if(value?.account_users){
          const accessParentAccount = value.account_users.find(account_user => account_user.account.id === this.currentAccountId);
          this.accessParent = this.accessParentOptions.find(option => option.id === (accessParentAccount ? 1 : 0));
          this.accounts = value.account_users.filter(account_user => account_user.account.id !== this.currentAccountId).map((account_user) => {
            return {
              account: account_user.account,
              role: this.roles.find(role => role.name === account_user.role),
            }
          });
        }else{
          this.accessParent = null;
          this.accounts = [];
        }
      },      
      immediate: true
    }
  },
  validations() {    
    return {
      agentName: {
        required,
        minLength: minLength(1),
      },
      agentEmail: {
        required,
        email,
      },
      accessParent: {
        required,
      },
      accounts: {
        minLength: (value) => {             
          if (this.accessParent === null || this.accessParent.id === 1) return true
          return value.length >= 1
        },
        $each: {        
          account: {
            required: requiredIf(() => this.accounts.length > 0),
          },
          role: {
            required: requiredIf(() => this.accounts.length > 0),
          },
        }
      }      
    }
  },  
  mounted() {    
    if(this.subaccounts.length === 0){
      this.$store.dispatch('subaccounts/get');
    }    
  },
  methods: {    
    onSubmit() {      
      this.$v.$touch()
      if (this.$v.$invalid) return;      

      let accountsAdd = this.accounts.map(item => ({
        id: item.account.id,
        role: item.role.name,
      }));
      if(this.accessParent.id){
        accountsAdd.push({
          id: this.currentAccountId,
          role: 'administrator',
        });
      }
      this.$emit('submit', {
        name: this.agentName,
        email: this.agentEmail,
        accounts: accountsAdd,
      });
    },
    removeRowAccount(index){
      this.accounts.splice(index, 1);      
    },
    addRowAccount(){
      this.accounts.push({
        account: null,
        role: null,
      });      
    },
    getSubaccountOptionsByIndex(index){
      const idsSelected = this.accounts.filter((item, i) => i !== index && item.account).map(item => item.account.id);
      return this.subaccountsSorted.filter(subaccount => !idsSelected.includes(subaccount.id));
    }
  },
};
</script>

<style lang="scss" scoped>
  .form-agent-multi-account{
    fieldset{
      width: 100%;
      border-radius: var(--border-radius-normal);
      border: 1px solid var(--color-border);      
      padding: 0 var(--space-normal);
      margin-bottom: var(--space-normal);
      legend{
        font-size: var(--font-size-medium);
        margin: 0 0 var(--space-normal) 0;
      }
      .medium-12{
        margin-bottom: 1.6rem;
        input{        
          margin: 0;
        }
      }
      
      .item-account{
        margin-bottom: var(--space-small);
        padding: var(--space-normal);
        border-radius: var(--border-radius-large);
        border: 1px solid var(--color-border);
        background: var(--color-background-light);
        margin-bottom: var(--space-normal);        
        .columns{
          &:not(.column-actions){
            width: calc(100% - 30px);
          }
          &.column-actions{
            max-width: 30px;
            display: flex;
            align-self: center;
          }
          margin-right: var(--space-small);
          &:last-of-type{
            margin-right: 0;
          }
        }
        .error .message{
          margin: 0;
        }
      }
    }
  }
</style>
